import React, { useEffect, useState } from "react";
import profileavtar from "../../assets/images/profileavtar.png";
import { Button, Dropdown, Menu, Badge as AntdBadge } from "antd";
import { Container, Image, Nav, Navbar } from "react-bootstrap";
import "antd/dist/antd.css";
import { getItem, showSuccessToast, onImageError } from "../../utils/Functions";
import { useHistory, useLocation } from "react-router-dom";
import { paths } from "../../router/Constant";
import logo from "../../assets/images/InicImg.png";
import { offeredCandidateProfile } from "../../pages/Profile/actions";
import { useDispatch, useSelector } from "react-redux";

export default function Topbar(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  let userInfo = JSON.parse(getItem("User") || "{}");
  let type = getItem("type");
  const [url, setUrl] = useState(null);

  // Theme state
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    if (theme === "dark") {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  // Active Nav state (single active item), derived from the current route
  const activeNav =
    location.pathname === paths.jobOpenings ? "openings" : "home";

  // Sticky Header
  const [scroll, setScroll] = useState(false);
  const [offerProfileData, setProfileCandidateData] = useState();
  const [offerProfileDatas, setOfferProfileDatas] = useState();
  const [photoUrl, setPhotoUrl] = useState("");
  const [baseUrl, setBaseUrl] = useState("");
  const offeredCandidateReduxData = useSelector(
    (state) => state.profile.OfferedCandidateProfileDetails
  );

  const logoutHandler = () => {
    history.push("/");
    localStorage.clear();
    showSuccessToast("Logout Successfully");
  };

  const userMenu = (
        // {
    //   key: "1",
    //   label: (
    //     <a onClick={() => history.push("/job-opening")}>
    //       <span className="bx bx-briefcase me-2"></span>Apply Job
    //     </a>
    //   ),
    // },
    <Menu
      className="header-profile-menu"
      items={[
        {
          key: "profile",
          label: (
            <div
              className="header-menu-item"
              onClick={() =>
                history.push(type === "candidate" ? "/profile" : "/add-profile")
              }
            >
              <i className="bx bx-user-circle text-orange" />
              <span>Complete your profile</span>
            </div>
          ),
        },
        {
          type: "divider",
        },
        {
          key: "logout",
          label: (
            <div className="header-menu-item" onClick={logoutHandler}>
              <i className="bx bx-log-out" />
              <span>Logout</span>
            </div>
          ),
        },
      ]}
    />
  );

  useEffect(() => {
    if (userInfo?._id) {
      dispatch(offeredCandidateProfile(userInfo._id));
    }
  }, [userInfo?._id]);

  useEffect(() => {
    if (offeredCandidateReduxData) {
      setProfileCandidateData(offeredCandidateReduxData.unseenDocCount);
      setOfferProfileDatas(offeredCandidateReduxData.unseenSigningDocCount);
      setPhotoUrl(offeredCandidateReduxData.photo);
      setBaseUrl(offeredCandidateReduxData.FILE_PATH);
    }
  }, [offeredCandidateReduxData]);

  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleHomeClick = () => {
    if (location.pathname !== paths.homeLanding) {
      history.push(paths.homeLanding);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleOpeningsClick = () => {
    if (location.pathname !== paths.jobOpenings) {
      history.push(paths.jobOpenings);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleAboutClick = () => {
    const el = document.getElementById("offerSection");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      history.push("/job-opening");
    }
  };

  return (
    // <header className={scroll ? "sticky candidate-topbar" : "candidate-topbar"}>
    <header
      className={`candidate-topbar ${props.minimal ? "" : "sticky"} ${props.headerHide ? "d-none" : ""} ${props.minimal ? "candidate-topbar--seamless" : ""}`}
    >
      <Container>
        <Navbar
          collapseOnSelect
          expand="lg"
          className="justify-content-between align-items-center"
        >
          <Navbar.Brand
            onClick={handleHomeClick}
            title="Job Openings"
            className="mb-0 cursor-pointer"
          >
            <Image
              src={logo}
              variant="top"
              className="header-img"
              alt="IndiaNIC Logo"
            />
          </Navbar.Brand>

          {!props.minimal && (
            <div className="right-side-nav d-flex align-items-center gap-3 gap-md-4">
              <div className="topbar-nav-links d-flex align-items-center gap-3 gap-md-4">
                <span
                  className={`topbar-nav-item ${activeNav === "home" ? "active" : ""}`}
                  onClick={handleHomeClick}
                >
                  Home
                </span>
                {/* <span
                className={`topbar-nav-item ${activeNav === "about" ? "active" : ""}`}
                onClick={handleAboutClick}
              >
                About
              </span> */}
                <span
                  className={`topbar-nav-item ${activeNav === "openings" ? "active" : ""}`}
                  onClick={handleOpeningsClick}
                >
                  Openings
                </span>
              </div>

              <button
                type="button"
                className="theme-toggle-btn"
                onClick={toggleTheme}
                title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
              >
                <i className={`bx ${theme === "dark" ? "bx-sun" : "bx-moon"}`} />
              </button>

              <Dropdown
                overlay={userMenu}
                placement="bottomRight"
                trigger={["click"]}
                arrow={{ pointAtCenter: true }}
              >
                <Button className="avtar-dropdown">
                  {photoUrl !== "" && photoUrl !== undefined ? (
                    <Image
                      width="32"
                      height="32"
                      src={baseUrl + photoUrl}
                      alt="User Image"
                      className="rounded-circle"
                    />
                  ) : (
                    <i className="bx bx-user" />
                  )}
                </Button>
              </Dropdown>
            </div>
          )}
        </Navbar>

        {/* <div className="d-flex justify-content-between align-items-center">
          <div className='left-side-content align-self-center'>
            <Link href="javascript:;">
              <Image src={logo} variant="top" className="header-img" />
            </Link>
          </div>

          <div className="doc-links">
            <Link href="#" className="me-3 active" title="My Documents" onClick={() => history.push("/document")}>My Documents</Link> 
            <Link href="#" className="" title="My Agreements" onClick={() => history.push("/agreement")}>My Agreements</Link> 
          </div>

          <div className="right-side-content align-self-center justify-content-end">
            <div className="notify align-self-center">
              <a href="#">
                <i class="bx bx-bell"></i>
              </a>
            </div>
            <div className="select-user align-self-center">
              <Dropdown
                overlay={menu}
                placement="bottom"
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <Button className="avtar-dropdown align-self-center">
                  <Image src={profileavtar} alt="User Image" />
                </Button>
              </Dropdown>
            </div>
          </div>
        </div> */}
      </Container>
    </header>
  );
}
